import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ChevronDownIcon } from 'lucide-react';
interface Publication {
  id: number;
  title: string;
  title_ar: string;
  description: string;
  description_ar: string;
  image: string;
  downloadUrl: string;
  category: 'reports' | 'articles' | 'research';
}
const publications: Publication[] = [{
  id: 1,
  title: 'Report 2025',
  title_ar: 'تقرير 2025',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/8fB4FqJ55RJ3xaNBikkXy9/Mask_Group_175.jpg',
  downloadUrl: '#',
  category: 'reports'
}, {
  id: 2,
  title: 'Forbes Interview',
  title_ar: 'مقابلة فوربس',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/kD3kH5BJLNunjY8bjB28un/Mask_Group_173.jpg',
  downloadUrl: '#',
  category: 'articles'
}, {
  id: 3,
  title: 'A New Way\nOf Development',
  title_ar: 'طريقة جديدة\nللتطوير',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/3mZ5vjuxwQf5KvXXc3wwv4/Mask_Group_174.jpg',
  downloadUrl: '#',
  category: 'research'
}, {
  id: 4,
  title: 'Report 2024',
  title_ar: 'تقرير 2024',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/8fB4FqJ55RJ3xaNBikkXy9/Mask_Group_175.jpg',
  downloadUrl: '#',
  category: 'reports'
}, {
  id: 5,
  title: 'Forbes Interview',
  title_ar: 'مقابلة فوربس',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/kD3kH5BJLNunjY8bjB28un/Mask_Group_173.jpg',
  downloadUrl: '#',
  category: 'articles'
}, {
  id: 6,
  title: 'A New Way\nOf Development',
  title_ar: 'طريقة جديدة\nللتطوير',
  description: 'Empowers financial institutions with seamless connectivity to local and international networks.',
  description_ar: 'تمكين المؤسسات المالية من الاتصال السلس بالشبكات المحلية والدولية.',
  image: 'https://cdn.magicpatterns.com/uploads/3mZ5vjuxwQf5KvXXc3wwv4/Mask_Group_174.jpg',
  downloadUrl: '#',
  category: 'research'
}];
export function PublicationsPage() {
  const {
    t,
    setLocale,
    direction,
    locale
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useScrollReveal();
  const [filter, setFilter] = useState('all');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  const filters = [{
    id: 'all',
    label: t('publicationsPage.filters.all')
  }, {
    id: 'reports',
    label: t('publicationsPage.filters.reports')
  }, {
    id: 'articles',
    label: t('publicationsPage.filters.articles')
  }, {
    id: 'research',
    label: t('publicationsPage.filters.research')
  }];
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const selectedFilter = filters.find(f => f.id === filter);
  const filteredPublications = publications.filter(item => filter === 'all' || item.category === filter);
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-1206">
      <Header variant="dark" data-id="element-1207" />

      <main data-id="element-1208">
        {/* White header background spacer */}
        <div className="bg-white h-20" data-id="element-1209" />

        {/* Hero Banner */}
        <section className="gradient-dark-horizontal py-16 md:py-20 relative overflow-hidden" ref={heroRef} aria-label="Publications Hero" data-id="element-1210">
          {/* Top-left decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/oSPxnKHLzspYqMxuH2SAJd/inner-top-left.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 left-0 w-[200px] md:w-[300px] h-auto pointer-events-none opacity-20" data-id="element-1211" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1212">
            <h1 className={`text-white font-bold leading-[1.1] mb-4 uppercase text-[32px] md:text-[44px] lg:text-[50px] reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-1213">
              {t('publicationsPage.hero.title')}
            </h1>
            <p className={`text-white/80 text-base md:text-lg whitespace-pre-line leading-relaxed max-w-lg reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-1214">
              {t('publicationsPage.hero.subtitle')}
            </p>
          </div>
        </section>

        {/* Publications Grid Section */}
        <section className="py-16 md:py-24 bg-white relative" ref={gridRef} aria-label="Publications" data-id="element-1215">
          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1216">
            {/* Filter */}
            <div className="flex justify-end mb-12" data-id="element-1217">
              <div className="flex items-center gap-6" data-id="element-1218">
                <span className="text-gray-400 font-medium text-sm" data-id="element-1219">
                  {t('publicationsPage.filterBy')}
                </span>

                {/* Custom Dropdown */}
                <div className="relative" ref={dropdownRef} data-id="element-1220">
                  <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="flex items-center gap-2 text-[#061D76] font-semibold text-sm focus:outline-none border-b border-[#061D76] pb-1 min-w-[120px] justify-between" data-id="element-1221">
                    {selectedFilter?.label}
                    <img src="https://cdn.magicpatterns.com/uploads/ixihkaPwGFYczLufQYWzAZ/download.svg" alt="" className="w-4 h-4" data-id="element-1222" />
                  </button>

                  {isDropdownOpen && <div className="absolute top-full right-0 mt-2 bg-white shadow-lg border border-gray-100 min-w-[180px] z-50" data-id="element-1223">
                      {filters.map(f => <button key={f.id} onClick={() => {
                    setFilter(f.id);
                    setIsDropdownOpen(false);
                  }} className={`block w-full text-right px-4 py-3 text-sm transition-colors ${filter === f.id ? 'bg-[#061D76] text-white font-semibold' : 'text-[#061D76] hover:bg-gray-50'}`} data-id="element-1224">
                          {f.label}
                        </button>)}
                    </div>}
                </div>
              </div>
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1225">
              {filteredPublications.map((item, index) => <a key={item.id} href={item.downloadUrl} download className={`group relative aspect-[3/4] overflow-hidden cursor-pointer reveal-hidden ${gridVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${index * 100}ms`
            }} data-id="element-1226">
                  {/* Background Image */}
                  <img src={item.image} alt={locale === 'ar' ? item.title_ar : item.title} className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-1227" />

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0" style={{
                background: 'linear-gradient(to top, #031045 0%, rgba(0, 0, 0, 0) 80%)'
              }} data-id="element-1228" />

                  {/* Download Icon */}
                  <div className="absolute top-4 right-4 z-10" data-id="element-1229">
                    <div className="w-10 h-10 rounded-full border border-white/50 flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-1230">
                      <img src="https://cdn.magicpatterns.com/uploads/ixihkaPwGFYczLufQYWzAZ/download.svg" alt="Download" className="w-5 h-5" data-id="element-1231" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 z-10" data-id="element-1232">
                    <h3 className="text-white font-bold text-lg md:text-xl leading-tight mb-3 whitespace-pre-line" data-id="element-1233">
                      {locale === 'ar' ? item.title_ar : item.title}
                    </h3>
                    <p className="text-white/80 text-sm leading-relaxed" data-id="element-1234">
                      {locale === 'ar' ? item.description_ar : item.description}
                    </p>
                  </div>
                </a>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1235" />
    </div>;
}